import React, {useState} from "react";
import { useTranslation } from "next-i18next";
import {
    CustomizeDataRetention,
    DataDrivenInsights,
    EnhanceSecurity,
    FasterIsseResolution,
    ImproveApplication,
    ImproveCustomer,
    MwSmallIcon,
    OptimizeInfra,
    PersonalizePlayerExperience,
    ReduceDowntimeMTTR,
    Scalable,
    ScalablePerformance,
    SeamlessGameplay,
    Training,
} from "../../components/v2/icons";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import Card from "../../components/v2/cards/card";
import CallToActionBlog from "../../components/v2/blog/call-to-action-blog";
import Dialog from "../../components/v2/dialog";
import ProductHeroSection from "../../components/v2/common/product-hero";
import SolutionFeatureSection from "../../components/v2/common/solution-feature";
import ClientTestimonials from "../../components/v2/mw-carousel/testimonial";
import SolutionsHeroSection from "../../components/v2/common/solutions-hero";
import CardWithIcon from "../../components/v2/cards/card-with-icon";
import TrustedCompanyTopHeading from "../../components/v2/mw-carousel/trust-company-heading-top";

export default function Gaming() {
    const { t } = useTranslation("common");
    const i18nData = t('solutions.gaming', { returnObjects: true }) as any

    const resource = Array.isArray(i18nData?.resources) ? i18nData.resources : []

    const sectionsData = Array.isArray(i18nData?.sections) ? i18nData.sections : []

    const heroCardDetails = Array.isArray(i18nData?.hero?.cards) ? i18nData.hero.cards : []

    return (
        <>

            <SolutionsHeroSection title={<h1><span className='text-gradient'>{i18nData?.hero?.titlePrefix}</span> {i18nData?.hero?.titleSuffix}</h1>} tag={i18nData?.hero?.tag} description={<p>{i18nData?.hero?.description}</p>} cardData={heroCardDetails} />

            <section className={"mw-card solutions-mw-card"}>
                <div className={"container"}>
                    <div className={"d-flex card-items"}>
                        <div className={"card-item"}>
                            <h2>
                                {i18nData?.sectionIntro?.title}
                            </h2>
                            <p>{i18nData?.sectionIntro?.description}</p>
                        </div>

                        {Array.isArray(i18nData?.introCards) && i18nData.introCards.length > 0 && (
                            <>
                                <CardWithIcon icon={<SeamlessGameplay/>} title={i18nData.introCards[0]?.title}
                                              description={i18nData.introCards[0]?.description}/>
                                {i18nData.introCards[1] && (
                                    <CardWithIcon icon={<DataDrivenInsights/>} title={i18nData.introCards[1]?.title}
                                                  description={i18nData.introCards[1]?.description}/>
                                )}
                                {i18nData.introCards[2] && (
                                    <CardWithIcon icon={<ScalablePerformance/>} title={i18nData.introCards[2]?.title}
                                                  description={i18nData.introCards[2]?.description}/>
                                )}
                                {i18nData.introCards[3] && (
                                    <CardWithIcon icon={<FasterIsseResolution/>} title={i18nData.introCards[3]?.title}
                                                  description={i18nData.introCards[3]?.description}/>
                                )}
                                {i18nData.introCards[4] && (
                                    <CardWithIcon icon={<PersonalizePlayerExperience/>} title={i18nData.introCards[4]?.title}
                                                  description={i18nData.introCards[4]?.description}/>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </section>

            <TrustedCompanyTopHeading/>

            <CallToActionBlog
                title={t('solutions.gaming.ctaTitle')}
                isSignupBtn={true}
                isButton={true}
            />

            <section className={"user-monitor solutions_page"} id={'know-more'}>
                <div className={"container"}>
                    <div className={'section-tag testimonial pd-right'}>{t('solutions.gaming.sectionTag')}</div>
                    <h2 dangerouslySetInnerHTML={{ __html: t('solutions.gaming.sectionHeading') }}></h2>

                    {sectionsData.map((section, index) => (
                        <SolutionFeatureSection
                            image={section.image}
                            imageAlt={section.imageAlt}
                            title={section.title}
                            list={section.list}
                            category={section.category}
                        />
                    ))}

                </div>
            </section>

            <ClientTestimonials />

            <ProductResources resources={resource}/>

        </>
    )
}